module.exports = __webpack_public_path__ + "8bc0fad15f16b7d12d6274197d402d5e.png";